import { createSlice } from "@reduxjs/toolkit";
import { setAnalyticsDashletConfig, setSelectedAnalyticsDashlet } from "./analyticsDashletConfig.action";

const analyticsConfigSlice = createSlice({
  name: "analyticsConfig",
  initialState: {
    analyticsDashletConfig: [],
    selectedAnalyticsDashlet: [],
  },
  reducers: {
    analyticsDashletConfig: setAnalyticsDashletConfig,
    selectedAnalyticsDashlet: setSelectedAnalyticsDashlet,
  },
});

export const { analyticsDashletConfig, selectedAnalyticsDashlet } = analyticsConfigSlice.actions;
export default analyticsConfigSlice.reducer;
